var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidebarPlus(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8690_1424)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 10.0003C2.5 9.77931 2.5878 9.56735 2.74408 9.41107C2.90036 9.25479 3.11232 9.16699 3.33333 9.16699H16.6667C16.8877 9.16699 17.0996 9.25479 17.2559 9.41107C17.4122 9.56735 17.5 9.77931 17.5 10.0003C17.5 10.2213 17.4122 10.4333 17.2559 10.5896C17.0996 10.7459 16.8877 10.8337 16.6667 10.8337H3.33333C3.11232 10.8337 2.90036 10.7459 2.74408 10.5896C2.5878 10.4333 2.5 10.2213 2.5 10.0003Z",
    fill: "#0A1129",
    fillOpacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99984 2.5C10.2209 2.5 10.4328 2.5878 10.5891 2.74408C10.7454 2.90036 10.8332 3.11232 10.8332 3.33333L10.8332 16.6667C10.8332 16.8877 10.7454 17.0996 10.5891 17.2559C10.4328 17.4122 10.2209 17.5 9.99984 17.5C9.77882 17.5 9.56686 17.4122 9.41058 17.2559C9.2543 17.0996 9.1665 16.8877 9.1665 16.6667L9.1665 3.33333C9.1665 3.11232 9.2543 2.90036 9.41058 2.74408C9.56686 2.5878 9.77882 2.5 9.99984 2.5Z",
    fill: "#0A1129",
    fillOpacity: 0.45
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8690_1424"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarPlus);
export default __webpack_public_path__ + "static/media/sidebar_plus.12b877f2ce9502394928e13b8b40a9b1.svg";
export { ForwardRef as ReactComponent };